
/**
 * This is to support TYTAppRedirect, because as of Angular 9 you must attach a component or redirect to a route,
 * but we don't really need one. So here's a component that does nothing.
 */

import { Component } from "@angular/core";

@Component({ template: '', styles: [] })
export class NoOpComponent {

}